export default __webpack_public_path__ + "static/media/about_point_three.ba22da97.svg";